/* @flow */

import React from 'react';
import { Header, Segment, Icon, Label } from 'semantic-ui-react';
import { AutoSizer, Table as FlexTable, Column } from 'react-virtualized';
import { withRouter } from 'react-router-dom';
import { isPageSecured } from 'catalog/plugin';
import { isPageLocked } from 'catalog/reducers/page';
import ConfirmDeleteButton from 'shared/components/ConfirmDeleteButton';
import PageTemplateLabel
  from 'catalog/screens/shared/components/PageTemplateLabel';

type Props = {
  pages: List<CatalogPage>,
  history: Object,
  onArchivePage: (page: CatalogPage) => void,
};

const ROW_HEIGHT: int = 55;
const HEADER_HEIGHT: int = 40;

// TODO: Allow grouping them in virtual folders
const PageList = ({ pages, history, onArchivePage }: Props) => {
  const modalDeleteContent = `
    Êtes-vous sûr(e) de vouloir désactiver cette page ?
    Elle disparaitra de l'arborescence mais restera disponible via l'onglet "Mes Archives"
  `;

  const navigateToPage = ({ rowData }) => history.push(`/pages/${rowData.id}`);

  const getRow = ({ index }) => pages.get(index);

  const computeListHeight = (rowCount, rowHeight, height) =>
    Math.min((rowCount + 1) * rowHeight + 15, height);

  const renderRootColumn = ({ cellData }) =>
    cellData && <Icon name="home" size="large" circular />;

  const renderSecurityColumn = ({ rowData }) => {
    if (isPageSecured(rowData)) {
      return <Label color="red">Activée</Label>;
    }
    return <Label>Inactive</Label>;
  };

  const renderTemplateColumn = ({ rowData }) => (
    <PageTemplateLabel page={rowData} />
  );
  const renderNameColumn = ({ cellData }) => (
    <Header as="h3" textAlign="center">{cellData}</Header>
  );
  const getRowStyle = ({ index }) =>
    index + 1 < pages.size && { borderBottom: '1px solid rgba(0,0,0,.1)' };

  const renderActionsColumn = ({ rowData }) => {
    const archive = () => onArchivePage(rowData);

    return (
      <div className="ui tiny buttons">
        {!isPageLocked(rowData) &&
          <ConfirmDeleteButton
            content="Archiver"
            icon={<Icon name="archive" />}
            className="red right labeled icon"
            modalTitle="Désactivation"
            modalContent={modalDeleteContent}
            onConfirm={archive}
          />}
      </div>
    );
  };

  const catalogPageListColumns = width => {
    const columnWidth = (columnWidth: int) => width / 16 * columnWidth;

    return [
      <Column
        key="root"
        dataKey="isRoot"
        width={columnWidth(1)}
        headerClassName="centered"
        cellRenderer={renderRootColumn}
        style={{ textAlign: 'center' }}
      />,
      <Column
        key="name"
        label="Nom"
        dataKey="name"
        width={columnWidth(6)}
        headerClassName="centered"
        cellRenderer={renderNameColumn}
        style={{ textAlign: 'center' }}
      />,
      <Column
        key="security"
        label="Securité"
        dataKey="security"
        width={columnWidth(3)}
        headerClassName="centered"
        cellRenderer={renderSecurityColumn}
        style={{ textAlign: 'center' }}
      />,
      <Column
        key="template"
        label="Type"
        dataKey="template"
        width={columnWidth(3)}
        headerClassName="centered"
        cellRenderer={renderTemplateColumn}
        style={{ textAlign: 'center' }}
      />,
      <Column
        key="act"
        label="Actions"
        dataKey="actions"
        width={columnWidth(4)}
        headerClassName="centered"
        cellRenderer={renderActionsColumn}
        style={{ textAlign: 'center' }}
      />,
    ];
  };

  return (
    <div style={{ height: '100%' }}>
      <AutoSizer>
        {({ width, height }) => (
          <Segment
            style={{
              width,
              height: computeListHeight(pages.size, ROW_HEIGHT, height),
            }}
          >
            <AutoSizer>
              {segmentDimentions => (
                <FlexTable
                  ref="Table"
                  width={segmentDimentions.width}
                  height={computeListHeight(
                    pages.size,
                    ROW_HEIGHT,
                    segmentDimentions.height
                  )}
                  rowHeight={ROW_HEIGHT}
                  headerHeight={HEADER_HEIGHT}
                  rowCount={pages.size}
                  rowGetter={getRow}
                  onRowClick={navigateToPage}
                  headerStyle={{ textAlign: 'center' }}
                  rowStyle={getRowStyle}
                >
                  {catalogPageListColumns(segmentDimentions.width)}
                </FlexTable>
              )}
            </AutoSizer>
          </Segment>
        )}
      </AutoSizer>
    </div>
  );
};

export default withRouter(PageList);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Pages/components/PageList.js